module.exports = __webpack_public_path__ + "img/jidian_shishi.e4faec5c.png";